import { UserName as a, EmailAddress as c, PhoneNumber as u } from "../types/validation-regex.js";
const d = (e) => e.replace(/[^a-z0-9]+/gi, ""), l = (e, r) => {
  let t = !1, n = !1, o;
  switch (r) {
    case "PHONE_NUMBER":
      o = u;
      break;
    case "EMAIL":
      o = c;
      break;
    case "FIRST_NAME":
    case "LAST_NAME":
      o = a;
      break;
    default:
      t = !0;
      break;
  }
  return o && (n = !0, t = o.test(e)), { validationPassed: t, hasValidationRule: n };
}, f = (e) => /[^/]+?(?=\?|$)/.exec(e)[0], p = ({ width: e, style: r, color: t }) => `${e} ${r} ${t}`, g = (e = "") => e.length ? e.split(" ").join("") : "", h = (e) => {
  if (typeof document < "u" && typeof getComputedStyle == "function") {
    const r = parseFloat(getComputedStyle(document.documentElement).fontSize) || 16;
    return e / r;
  }
  return e / 16;
}, m = (e) => {
  const r = /^(\d+(?:\.\d+)?)rem$/, t = e.match(r);
  return t && t.length === 2;
}, s = (e) => {
  const r = /^(\d+(?:\.\d+)?)rem$/, t = e.match(r);
  return t && t.length === 2 ? parseFloat(t[1]) : 0;
}, S = (e) => {
  var t;
  if (!m(e)) return 0;
  if (typeof document < "u" && typeof getComputedStyle == "function") {
    const n = parseFloat((t = getComputedStyle(document.documentElement)) == null ? void 0 : t.fontSize) || 16;
    return Math.round(s(e) * n);
  }
  return Math.round(s(e) * 16);
}, y = (e) => typeof e == "string" ? Number(e) : e, N = () => typeof window < "u";
export {
  d as generateKey,
  p as getFormattedBorderString,
  f as getLastOfUrlNoParams,
  N as isBrowser,
  y as parseContinuityValue,
  h as pxToRem,
  l as reExpValidation,
  S as remToPixelsNumber,
  g as removeCharacterSpaces
};
